import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Response } from '../../../shared/models/response.model';
import { Phase } from './models/phase.model';
import { PhaseCreateRequest } from './requests/create-request';
import { UpdateRequest } from './requests/update-request';

@Injectable({
  providedIn: 'root',
})
export class ProcessusPhaseService {
  #http = inject(HttpClient);

  readonly BASE_URL = `/phases`;

  findAll(idReferentiel: string) {
    return this.#http.get<Response<Phase>>(this.BASE_URL, { params: { idReferentiel } });
  }

  findById(idPhase: string): Observable<Phase> {
    return this.#http.get<Phase>(this.BASE_URL + '/' + idPhase);
  }

  créer = (data: PhaseCreateRequest) => this.#http.post<Phase[]>(this.BASE_URL, data);

  modifier(idLivrable: string, data: UpdateRequest) {
    return this.#http.put<{ path: string }>(this.BASE_URL + '/' + idLivrable, data);
  }

  supprimer(idPhase: string) {
    return this.#http.delete<void>(this.BASE_URL + '/' + idPhase);
  }
}
